import type { GTableBoxPaddingBase } from '~/presentation/ui';
import type { ReactNode } from 'react';

import { useGTableContext } from '~/presentation/ui';
import { Box, InlineGrid } from '@shopify/polaris';

export const Row = ({
  children,
  padding,
  mode = 'body',
}: {
  children: ReactNode;
  padding?: GTableBoxPaddingBase;
  mode?: 'head' | 'body';
}) => {
  const { columnHead, columnBody } = useGTableContext();

  return (
    <Box {...padding}>
      <InlineGrid alignItems="center" columns={mode === 'head' ? columnHead : columnBody}>
        {children}
      </InlineGrid>
    </Box>
  );
};
